import { OrderTradingSessionEnum } from '@eih-netbroker/api-order';

export const TradingSession = OrderTradingSessionEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TradingSession = (typeof TradingSession)[keyof typeof TradingSession];
